var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H5V20H19V12Z",
    stroke: "#EE001D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8H4V12H20V8Z",
    stroke: "#EE001D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5C12 6.5 9.82843 6.5 9 6.5C9 6.5 8 6.32843 8 5.5C8 4.67157 8.67157 4 9.5 4C10.3284 4 12 5.67157 12 6.5Z",
    stroke: "#F3A01B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5C12 6.5 14.1716 6.5 15 6.5C15 6.5 16 6.32843 16 5.5C16 4.67157 15.3284 4 14.5 4C13.6716 4 12 5.67157 12 6.5Z",
    stroke: "#F3A01B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V19",
    stroke: "#F3A01B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackaging);
export default __webpack_public_path__ + "static/media/Packaging.f6d85856743c56f2166b017c3c4198fe.svg";
export { ForwardRef as ReactComponent };